
export const newsletterFormFields = [
  {
    key: 'last_name',
    label: 'نام و نام خانوادگی',
    name: 'last_name',
    isRequired: true,
    defaultValue: null,
    type: 'name'
  },
  {
    key: 'mobile',
    label: 'موبایل',
    name: 'mobile',
    isRequired: true,
    defaultValue: null,
    type: 'tel'
  },
  {
    key: 'email',
    label: 'ایمیل',
    name: 'email',
    isRequired: true,
    defaultValue: null,
    type: 'mail'
  },
  {
    key: 'position',
    label: 'سمت شغلی',
    name: 'position',
    isRequired: false,
    defaultValue: null,
    type: 'text'
  },
  {
    key: 'company_name',
    label: 'نام شرکت',
    name: 'company_name',
    isRequired: false,
    defaultValue: null,
    type: 'text'
  },
  {
    key: 'title',
    label: 'موضوع درخواست',
    name: 'title',
    isRequired: true,
    defaultValue: null,
    type: 'text'
  },
  {
    key: 'description',
    label: 'توضیحات درخواست',
    name: 'description',
    isRequired: true,
    defaultValue: null,
    type: 'textarea'
  }
]

export const consultingRequestFormFields = [
  {
    key: 'last_name',
    label: 'نام و نام خانوادگی',
    name: 'last_name',
    isRequired: true,
    defaultValue: null,
    type: 'name'
  },
  {
    key: 'mobile',
    label: 'موبایل',
    name: 'mobile',
    isRequired: true,
    defaultValue: null,
    type: 'tel'
  },
  {
    key: 'email',
    label: 'ایمیل',
    name: 'email',
    isRequired: true,
    defaultValue: null,
    type: 'mail'
  },
  {
    key: 'position',
    label: 'سمت شغلی',
    name: 'position',
    isRequired: false,
    defaultValue: null,
    type: 'text'
  },
  {
    key: 'company_name',
    label: 'نام شرکت',
    name: 'company_name',
    isRequired: false,
    defaultValue: null,
    type: 'text'
  },
  {
    key: 'title',
    label: 'موضوع درخواست',
    name: 'title',
    isRequired: true,
    defaultValue: null,
    type: 'text'
  },
  {
    key: 'description',
    label: 'توضیحات درخواست',
    name: 'description',
    isRequired: true,
    defaultValue: null,
    type: 'textarea'
  }
]

export const jobRequestFormFields = [
  {
    key: 'last_name',
    label: 'نام و نام خانوادگی',
    name: 'last_name',
    isRequired: true,
    defaultValue: null,
    type: 'name'
  },
  {
    key: 'mobile',
    label: 'موبایل',
    name: 'mobile',
    isRequired: true,
    defaultValue: null,
    type: 'tel'
  },
  {
    key: 'email',
    label: 'ایمیل',
    name: 'email',
    isRequired: true,
    defaultValue: null,
    type: 'mail'
  },
  {
    key: 'job_title',
    label: 'عنوان شغلی',
    name: 'job_title',
    isRequired: true,
    defaultValue: null,
    type: 'string'
  },
  {
    key: 'cv_file',
    label: 'فایل رزومه(PDF)',
    name: 'cv_file',
    isRequired: true,
    defaultValue: null,
    type: 'file',
    file_type: 'pdf'
  }
]
